module.exports = __webpack_public_path__ + "static/media/dec-id-back.cecdf6f0.gif";